(() => {
  'use strict';
  customElements.whenDefined('kd-led-concept').then(() => {
    class KDLedProduct extends customElements.get('kd-led-concept') {
      connectedCallback() {
        if (this.controller) return;
        this.config = JSON.parse(this.querySelector('[data-led-product-config]').textContent);
        this.labels = this.config.labels;
        super.connectedCallback();
        this.generation = this.querySelector('[data-led-generation]');
        this.error = this.querySelector('[data-kd-load-error]');
        const signal = this.controller.signal;
        const paint = this.querySelector('[data-vehicle-paint]');
        const paintLayer = this.querySelector('[data-led-paint-layer]');
        if (paint && paintLayer) {
          const updatePaint = () => {
            paintLayer.style.backgroundColor = paint.selectedOptions[0].dataset.hex;
            paintLayer.hidden = paint.value === 'White';
          };
          paint.addEventListener('change', updatePaint, {signal});
          updatePaint();
        }
        this.base.addEventListener('load', () => this.loaded(), {signal});
        this.base.addEventListener('error', () => {
          this.base.hidden = true;
          this.error.hidden = false;
          this.stage.setAttribute('aria-busy', 'false');
          this.sync();
        }, {signal});
        this.generation?.addEventListener('change', () => this.changeVehicle(), {signal});
        this.changeVehicle();
      }
      changeVehicle() {
        const key = this.generation?.selectedOptions[0]?.dataset.key || this.config.defaultGeneration;
        const vehicle = this.config.generations[key];
        const [x,y,w,h] = vehicle.panel;
        for (const [name,value] of Object.entries({x:x/12,y:y/8,w:w/12,h:h/8})) this.style.setProperty('--led-'+name, value+'%');
        this.dataset.vehicle = key;
        // Hidden lazy images can wait forever for visibility before loading.
        this.base.loading = 'eager';
        this.base.hidden = true;
        this.error.hidden = true;
        this.stage.setAttribute('aria-busy', 'true');
        this.base.alt = vehicle.label;
        this.base.src = vehicle.source;
        if (this.base.complete && this.base.naturalWidth) this.loaded();
        else this.sync();
      }
      loaded() {
        this.base.hidden = false;
        this.error.hidden = true;
        this.stage.setAttribute('aria-busy', 'false');
        this.sync();
      }
      sync() {
        super.sync();
        this.pause.textContent = this.paused ? this.labels.play : this.labels.pause;
        this.pause.setAttribute('aria-pressed', String(this.paused));
        this.status.textContent = this.pause.textContent;
      }
      draw() {
        super.draw();
        this.sceneLabel.textContent = '';
        this.panel.setAttribute('aria-label', this.labels.preview);
      }
    }
    if (!customElements.get('kd-led-product')) customElements.define('kd-led-product', KDLedProduct);
  });
})();
